import { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import AddUserDialog from '../Dialogs/AddUserDialog';
import FormattedAlias from '@components/_shared/Translations/FormattedAlias';

function AddUserButton() {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Button onClick={() => setDialogOpen(true)}>
        <AddIcon />
        <FormattedAlias id='Add User' />
      </Button>
      {dialogOpen && (
        <AddUserDialog open onClose={() => setDialogOpen(false)} />
      )}
    </>
  );
}

export default AddUserButton;
